// The root enum is the single definition, so a new param type is added in one place.
export {AuditParamType} from '../../../types/AuditParamType';
